// npm
import React from 'react'
import {
  useParams,
} from 'react-router-dom'

// components
import ContentLayout from '../components/ContentLayout.jsx'
import ItemList from '../components/ItemList.jsx'

export default function DomainPage() {
  const { domainName } = useParams()

  return (
    <ContentLayout title={ `Domain ${domainName}!` }>
      <p>Domain <code>{ domainName }</code> Page</p>
      <ItemList />
    </ContentLayout>
  )
}
